<template>
  <div class="list-page-comp">
    <slot name="header"></slot>

    <el-table
      :data="currData"
      :header-cell-style="headerCellStyle"
      tooltip-effect="light"
      stripe
      @sort-change="sortChange"
      v-bind="$attrs"
    >
      <slot />
    </el-table>

    <el-pagination
      :total="total"
      :page-size="size"
      @size-change="sizeChange"
      @current-change="pageChange"
      layout="total, sizes, ->, prev, pager, next, jumper"
      v-if="showPagination"
    >
    </el-pagination>
    <slot name="footer"></slot>
  </div>
</template>

<script lang="ts">
import orderBy from 'lodash/orderBy'
import { IPagination } from 'kuaidong-model'
import { BaseComponent, Component, Prop, Emit, Watch } from './base'

@Component
export default class ListPageComponent extends BaseComponent {
  @Prop({
    type: Array,
    default() {
      return []
    },
  })
  data!: Array<unknown>

  @Prop({ type: Object })
  paginationData?: IPagination<unknown>

  @Prop({ type: Number, default: 10 })
  limit!: number

  @Prop({ type: Number, default: 0 })
  offset!: number

  @Prop({
    type: Object,
    required: false,
    default: () => {
      return {
        background: '#F7F8FA',
      }
    },
  })
  headerCellStyle?: Record<string, string | number>

  size = this.limit

  page = this.offset

  order = ''
  orderProp = ''

  get total() {
    return this.isRealPagination ? this.paginationData!.count : this.data.length
  }

  get currData() {
    const start = this.page * this.size
    const end = start + this.size

    return this.isRealPagination ? this.paginationData!.items : this.orderedData.slice(start, end)
  }

  get orderedData() {
    if (this.order === 'ascending') {
      return orderBy([...this.data], this.orderProp, 'asc')
    } else if (this.order === 'descending') {
      return orderBy([...this.data], this.orderProp, 'desc')
    } else {
      return [...this.data]
    }
  }

  get showPagination() {
    return this.isRealPagination || this.total > this.size
  }

  get isRealPagination() {
    return !!this.paginationData
  }

  @Emit('page-change')
  pageChange(page: number) {
    this.page = page - 1

    this.change()

    return this.page
  }

  @Emit('size-change')
  sizeChange(size: number) {
    this.size = size

    this.change()

    return this.size
  }

  @Watch('limit')
  onLimitChange(limit: number) {
    this.size = limit
  }

  @Watch('data')
  onDataChange() {
    if (this.data.length < this.limit) {
      this.page = 0
    }
  }
  @Watch('offset')
  onOffsetChange(offset: number) {
    this.page = offset
  }

  change() {
    this.$emit('change', {
      limit: this.size,
      offset: this.page,
    })
  }

  sortChange({ prop, order }: { prop: string; order: string }) {
    this.order = order
    this.orderProp = prop
  }
}
</script>

<style lang="less">
@import '../assets/style/status';

.list-page-comp {
  padding: 28px;
  background: #fff;
  border-radius: 8px;

  .el-table-column {
    .el-button {
      padding: 0;

      &.danger {
        color: #f56c6c;
      }
    }
  }

  > .el-table {
    border: 1px solid #e4e7ed;
    border-radius: 8px;
    .status-use();
  }

  > .el-pagination {
    margin: 10px 0 0 0;
  }
}
</style>
